import { EventEmitter } from '@angular/core';
import { ConfirmationModalComponent } from './confirmation-modal.component';

export class ConfirmationModalRef {
    public confirmationModalComponent: ConfirmationModalComponent;
    public buttonClicked = new EventEmitter<string | boolean>();
}
